














import {Component, Vue, Watch} from 'vue-property-decorator';
import {Call, Sync} from 'vuex-pathify';
import {VueRouter} from 'vue-router/types/router';
import {CONDITIONAL_DISCOUNTS, nil} from '@/common';
import {Mixins} from 'vue-property-decorator';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';

@Component({
    components: {},
})
export default class BookingHome extends Mixins(GlobalAlertMixin) {
    public transitionName: string = 'slide-left';

    @Sync('booking/step') public currentStep!: number;

    public steps = [
        {
            // fas fa-map-signs
            icon: 'fas fa-map-marker-alt',
            text: 'Choose a Location',
            miniText: 'Location',
            undo: () => {
                this.setFormattedAddress(null);
                this.setLatitude(null);
                this.setLongitude(null);
            },
            navigate(router: VueRouter, forward: boolean = true) {
                router.replace('/book');
            },
        },
        {
            text: 'Choose a Category',
            miniText: 'Category',
            icon: 'fas fa-question',
            undo: () => {
                this.setCategory(undefined);
                this.setTier(undefined);
                this.setServiceType(undefined);
            },
            navigate(router: VueRouter, forward: boolean = true) {
                forward ? router.push('/book/category') : router.replace('/book/category');
            },
        },
        {
            text: 'Choose a Service',
            icon: 'fas fa-cut',
            miniText: 'Service',
            undo: () => {
                this.setServices([]);
                this.setGuests([]);
            },
            navigate(router: VueRouter, forward: boolean = true) {
                forward ? router.push('/book/service') : router.replace('/book/service');
            },
        },
        {
            text: 'Choose a Time',
            miniText: 'Time',
            icon: 'fas fa-clock',
            undo: () => {
                this.setEditingService(0);
                this.setTimes([]);
                this.setDates([]);
                this.setVendors([]);
            },
            navigate(router: VueRouter, forward: boolean = true) {
                forward ? router.push('/book/time') : router.replace('/book/time');
            },
        },
        {
            text: 'Checkout',
            miniText: 'Checkout',
            icon: 'fas fa-shopping-cart',
            undo: () => {
                this.setGuests([]);
                this.setDurations([]);
            },
            navigate(router: VueRouter, forward: boolean = true) {
                forward ? router.push('/book/cart') : router.replace('/book/cart');
            },
        },
    ];
    @Call('booking/setTier') public setTier!: (tier: any) => any;
    @Call('booking/setServiceType') public setServiceType!: (tag: string | undefined) => string;
    @Call('booking/setFormattedAddress') private setFormattedAddress!: (formattedAddress: string | null) => string;
    @Call('booking/setLatitude') private setLatitude!: (latitude: number | null) => number;
    @Call('booking/setLongitude') private setLongitude!: (longitude: number | null) => number;
    @Call('booking/setCategory') private setCategory!: (rate: any) => any;
    @Call('booking/setServices') private setServices!: (service: any[]) => any;
    @Call('booking/setEditingService') private setEditingService!: (editingService: number) => number;
    @Call('booking/setTimes') private setTimes!: (time: string[]) => string[];
    @Call('booking/setDates') private setDates!: (dates: string[]) => string[];
    @Call('booking/setVendors') private setVendors!: (vendors: any[]) => any[];
    @Call('booking/setGuests') private setGuests!: (guests: number[]) => number[];
    @Call('booking/setDurations') private setDurations!: (durations: number[]) => number[];
    @Sync('booking/discountConditional') public discountConditional!: string;


    @Watch('$route')
    public onRouteChanged(value: any, oldValue: any) {
        const toDepth = value.path.split('/').length;
        const fromDepth = oldValue.path.split('/').length;
        this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
    }

    @Watch('currentStep')
    public onCurrentStepChanged(value: number, oldValue: number) {
        if (value > oldValue) {
            if (!nil(this.discountConditional, true)) {
                // check to ensure the conditional discount still applies.
                const error = CONDITIONAL_DISCOUNTS[this.discountConditional](this.$store.state.booking);
                if (error !== false && value > 2) {
                    this.showAlert(error, 'warning');
                }
            }
            this.steps[value - 1].navigate(this.$router);
        } else {
            let indexWas = oldValue - 1;
            const indexIs = value - 1;
            const jumpBy = oldValue - indexIs;
            while (indexWas >= indexIs) {
                this.steps[indexWas].undo();
                indexWas--;
            }
            // this.$router.go(-jumpBy)

            this.steps[indexIs].navigate(this.$router, false);
        }
    }
}
